import APIController from '../core-api-controller';

export const fetchAppointmentsApi = (paramsObj = {}, paramsStr = '') => {
  const path = `${APIController.endpointApi}/appointments${paramsStr ? paramsStr : ''}`;
  return APIController.getApiCallback(path, paramsObj);
};

export const syncAppointmentsApi = (id = '') => {
  const path = `${APIController.endpointApi}/leads/${id}/sync_appointments`;
  return APIController.getApiCallback(path);
};

export const cancelReasonAppointmentApi = () => {
  const path = `${APIController.endpointApi}/client_user/lab_orders/appointment_cancel_reasons`;
  return APIController.getApiCallback(path);
};

export const cancelAppointmentApi = (id = '', obj = {}) => {
  const path = `${APIController.endpointApi}/client_user/lab_orders/${id}/cancel_appointment`;
  return APIController.postCallback(path, obj);
};

export const getAppointmentLinkApi = (intakeId = '') => {
  const path = `${APIController.endpointApi}/client_user/intakes/${intakeId}/fetch_appointment_link`;
  return APIController.getApiCallback(path);
};
